module.exports = __webpack_public_path__ + "banquet/components/images/quantity_decrease.226ec4a6c4e181448f1c7e24c237602b.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/quantity_decrease.svg
// module id = 1042
// module chunks = 1